import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import type { HookMap } from '@toast-ui/editor';
import { pipe } from 'fp-ts/function';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { withAsyncContainer } from '@mews-commander/ui';
import { uploadTaskImage } from '@mews-commander/legacy-entities/src/actions/tasks';
import TasksForm from '../components/TasksForm';
import {
    getCurrentDepartmentsOption,
    getTaskFormValues,
    isFetching,
    hasFailed,
    getTaskFormattedMeta,
} from '../selectors';
import { updateTaskData } from '../actions/actions';

const connectedTaskEditForm = connect(
    // @ts-expect-error $TSFixMeError: Property 'taskId' does not exist on type '{}'.
    (state, { taskId, scope }) => ({
        departments: getCurrentDepartmentsOption(state),
        // @ts-expect-error $TSFixMeError: Expected 1 arguments, but got 2.
        initialValues: getTaskFormValues(state, { taskId }),
        taskMeta: getTaskFormattedMeta(state, { id: taskId, enterpriseId: scope }),
    }),
    // @ts-expect-error $TSFixMeError: Property 'taskId' does not exist on type '{}'.
    (dispatch: CommanderThunkDispatch, { taskId }) => ({
        onSubmit: (values: $TSFixMe) => dispatch(updateTaskData(values, taskId)),
        markdownEditorHooks: {
            addImageBlobHook: async (blob, callback) => {
                const {
                    value: { url },
                } = await dispatch(uploadTaskImage(blob, taskId));
                callback(url);
            },
        } as HookMap,
    })
    // @ts-expect-error $TSFixMeError: Form values interface doesn't match types of initial values
)(TasksForm({ updateTask: true }));

export default pipe(
    connectedTaskEditForm,
    connect(
        createStructuredSelector({
            isFetching,
            hasFailed,
        })
    ),
    withAsyncContainer
);
